import HasFormGetters from "@/store/base/hasForm/getters"

export default Object.assign(HasFormGetters, {
  //
})